var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.857,
    height: 15.52,
    viewBox: "0 0 17.857 15.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1a2d00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.291,33.611l-1.616-1.278a1.691,1.691,0,0,0-1.071-.376,1.739,1.739,0,0,0-1.315.6c-.207.244-.338.395-.413.489a3.124,3.124,0,0,1-1.6-.977,3.123,3.123,0,0,1-.977-1.6c.075-.075.244-.207.489-.413a1.714,1.714,0,0,0,.225-2.386L6.738,26.058A1.747,1.747,0,0,0,5.385,25.4a1.778,1.778,0,0,0-.7.15,4.6,4.6,0,0,0-1.39.921c-.489.489-1.184,1.635-.357,3.852A12.358,12.358,0,0,0,5.817,34.55c1.992,1.992,4.34,3.232,6.106,3.232a2.7,2.7,0,0,0,1.954-.733,5.423,5.423,0,0,0,.921-1.39A1.711,1.711,0,0,0,14.291,33.611Zm-.338,1.672a4.186,4.186,0,0,1-.714,1.109,1.776,1.776,0,0,1-1.3.47c-1.466,0-3.589-1.109-5.468-2.987-2.555-2.574-3.7-5.6-2.518-6.764A3.9,3.9,0,0,1,5.066,26.4a.878.878,0,0,1,.319-.056.793.793,0,0,1,.62.3l1.278,1.616a.793.793,0,0,1-.113,1.09c-.338.282-.564.489-.62.545-.489.489-.019,1.766,1.052,2.856a3.817,3.817,0,0,0,2.292,1.259.741.741,0,0,0,.545-.188c.056-.056.263-.282.545-.62a.765.765,0,0,1,.6-.282.811.811,0,0,1,.489.169l1.616,1.278A.761.761,0,0,1,13.953,35.283Z",
    transform: "translate(-2.559 -22.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.453,8.7h-4.1a3.451,3.451,0,0,0-2.067,6.219,5.273,5.273,0,0,1-.357.582.848.848,0,0,0-.019.977.826.826,0,0,0,.7.376.943.943,0,0,0,.225-.038,11.242,11.242,0,0,0,2.724-1.2h2.912A3.457,3.457,0,1,0,46.453,8.7Zm0,5.956H43.409a.378.378,0,0,0-.244.075,10.974,10.974,0,0,1-2.33,1.09,6.425,6.425,0,0,0,.489-.883.483.483,0,0,0-.188-.62A2.522,2.522,0,0,1,42.376,9.6h4.1A2.518,2.518,0,0,1,48.99,12.12,2.55,2.55,0,0,1,46.453,14.656Z",
    transform: "translate(-32.072 -8.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.77,
    cy: 0.77,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(9.195 2.687)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.77,
    cy: 0.77,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(11.563 2.687)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.77,
    cy: 0.77,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(13.949 2.687)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.3f52b8393ddabf1658946b1aebdff1ab.svg";
export { ForwardRef as ReactComponent };